import { Offcanvas } from "react-bootstrap";

const Recipients = ({ recipientsCanvas, setRecipientsCanvas }) => {
    return (
        <Offcanvas show={recipientsCanvas.show} onHide={() => {
            setRecipientsCanvas((prevState) => ({ ...prevState, show: false }));
        }} placement='end' style={{ width: '40%' }}>
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Recipients</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="pt-3">
                {/* Make table with data name, email, whatsapp */}
                <table className="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Whatsapp</th>
                        </tr>
                    </thead>
                    <tbody>
                        {recipientsCanvas.data.map((recipient, index) => (
                            <tr key={index}>
                                <td>{recipient.name}</td>
                                <td>
                                    <a href={`mailto:${recipient.email}`} target="_blank">
                                        {recipient.email}
                                    </a>
                                </td>
                                <td>
                                    <a href={`https://wa.me/${recipient.whatsapp}`} target="_blank">
                                        {recipient.whatsapp}
                                    </a>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default Recipients;